<template>
  <SimpleDataCard
      :title="'Toplam B2B Sipariş Tutarı'"
      :data="numberConverter(reportCompanyData.totalB2bSale,'TRY')"
      :description="'Tüm Zamanlar'"
      :loading="stockDetailDataLoading"
      route="b2b-order-list"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";


export default {
  name: "ToplamB2BSiparisTutari",
  components: {
    SimpleDataCard
  },
  computed:{
    ...mapState("dashboard",["reportCompanyData","stockDetailDataLoading"])
  },
  methods: {
    numberConverter
  }
}
</script>

<style scoped>

</style>